import type { ImageFilter } from 'types/photo_types';

export const imageFilters: ImageFilter[] = [
  {
    title: 'Original',
    filterType: 'original',
    filePathThumb: 'file_path_thumb',
    filePathFull: 'file_path_1024',
  },
  {
    title: 'B&W',
    filterType: 'bw',
    filePathThumb: 'file_path_thumb_bw',
    filePathFull: 'file_path_1024_bw',
  },
  {
    title: 'Sepia 1',
    filterType: 'sepia1',
    filePathThumb: 'file_path_thumb_sepia1',
    filePathFull: 'file_path_1024_sepia1',
  },
  {
    title: 'Sepia 2',
    filterType: 'sepia2',
    filePathThumb: 'file_path_thumb_sepia2',
    filePathFull: 'file_path_1024_sepia2',
  },
];

export function createRotatedImageBlob(blob: Blob, degrees: number) {
  return new Promise<Blob>((res, rej) => {
    const canvas = document.createElement('canvas');
    // This cast is safe, getContext only returns null if the argument is incorrect
    const context = canvas.getContext('2d') as CanvasRenderingContext2D;
    const img = new Image();
    const src = URL.createObjectURL(blob);

    img.addEventListener('load', () => {
      // Set the height of the canvas to the size the rotated image will be, swapping height/width if
      // the rotation will flip the aspect ratio
      const flipAspectRatio = (degrees / 90) % 2 !== 0;
      canvas.height = flipAspectRatio ? img.width : img.height;
      canvas.width = flipAspectRatio ? img.height : img.width;

      // Move the context origin to the center of the canvas
      context.translate(canvas.width / 2, canvas.height / 2);

      // Rotate the context matrix
      const rads = Math.PI / 180;
      context.rotate(degrees * rads);

      // Move the context origin back to the top-left of the rotated context
      context.translate(canvas.height / -2, canvas.width / -2);

      // Draw the image at the origin
      context.drawImage(img, 0, 0);

      // Convert the canvas to a blob, rejecting the promise if this callback returns null
      canvas.toBlob((blobOut) => {
        if (!blobOut) {
          rej('No blob');
          return;
        }

        res(blobOut);
        // Clean up the object url for the original image we rotated
        URL.revokeObjectURL(src);
      });
    });

    img.src = src;
  });
}
